<template>
  <div class="visa-knowledge">
    <div class="center-content" :class="{ 'for-ie': isIE, 'for-other': !isIE }">
      <div class="category-types">
        <router-link
          active-class="acive"
          :to="'/visa-knowledge/latest-news'"
          class="category-item"
          >最新资讯</router-link
        >
        <router-link
          active-class="acive"
          :to="'/visa-knowledge/case-analysis'"
          class="category-item"
          >案例解析</router-link
        >
        <router-link
          active-class="acive"
          :to="'/visa-knowledge/visa-open-class'"
          class="category-item"
          >签证公开课</router-link
        >
        <router-link
          active-class="acive"
          :to="'/visa-knowledge/visa-guide'"
          class="category-item"
          >办签指南</router-link
        >
      </div>
      <router-view></router-view>
    </div>
    <favorite-page></favorite-page>
  </div>
</template>

<script>
import favoritePage from "./components/favorite-page";
import utils from '../../libs/utils';

export default {
  name: "visa-knowledge",
  components: {
    favoritePage,
  },
  data() {
    return {
      isIE: utils.isIE()
    }
  },
};
</script>

<style lang="less" scoped>
.visa-knowledge {
  background-color: white;
  display: flex;
  min-height: calc(~"100vh - 395px");
  flex-direction: column;
  .center-content {
    width: 1120px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;
    &.for-ie {
      height: 1080px;
    }
    &.for-other {
      flex: 1;
    }
    .category-types {
      margin-top: 48px;
      align-self: center;
      display: flex;
      align-items: center;
      cursor: pointer;
      .category-item {
        font-size: 24px;
        font-weight: 600;
        color: #2f333d;
        line-height: 24px;
        margin-right: 80px;
        position: relative;
        &:hover,
        &.acive {
          color: #599fff;
        }
        &.acive {
          color: #599fff;
          &::after {
            content: "";
            width: 30px;
            height: 4px;
            background: #599fff;
            border-radius: 1px;
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/VisaKnowledge.vue